// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".EventOverview{position:relative}.EventOverview .rounded-corner{border-top-right-radius:128px;overflow:hidden}.EventOverview .imageDisplay{cursor:pointer}.EventOverview img{aspect-ratio:16/10;-o-object-fit:contain;object-fit:contain;-o-object-position:50% 50%;object-position:50% 50%;width:100%}.EventOverview h3{font-size:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
